import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Constants} from '../shared/constants';
import {HeaderFilterOption, LoadOptions} from '../shared/models/shared.model';
import {Observable} from 'rxjs';
import {
	BarcodeMappingWithGlobalCompanyPrefixGridResult,
	NewBarcodeGlobalCompanyPrefixMapping
} from '../shared/models/barcode-mapping.model';
import {HeaderFilterData} from '../shared/models/product.model';

@Injectable({
  providedIn: 'root'
})
export class BarcodeDataService {
  private token = localStorage.getItem('token');
  private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });

  private url = Constants.devServerEndpoint + 'api/barcodemapping';

  constructor(private httpClient: HttpClient) { }

  public getGlobalCompanyPrefixMappingGrid(param: LoadOptions): Observable<BarcodeMappingWithGlobalCompanyPrefixGridResult> {
	return this.httpClient
		.post<BarcodeMappingWithGlobalCompanyPrefixGridResult>(
		this.url + `/getGlobalCompanyPrefixMappingGrid`, param,
		{ headers: this.headers }
		);
  }

  public getHeaderFiltersGlobalCompanyPrefixMapping(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
	return this.httpClient
		.post<HeaderFilterData[]>(
		this.url + `/getHeaderFiltersGlobalCompanyPrefixMapping`, param,
		{ headers: this.headers }
		);
  }

  public mappingGlobalCompanyPrefixAction(param): Observable<any> {
	return this.httpClient
		.post<any>(
		this.url + '/mappingGlobalCompanyPrefixAction', param,
		{ headers: this.headers }
		);
  }

  public saveGlobalCompanyPrefixData(data: NewBarcodeGlobalCompanyPrefixMapping) {
	return this.httpClient
		.post<any>(
		this.url + '/saveGlobalCompanyPrefixData', data,
		{ headers: this.headers }
		);
  }

}
